import React from 'react';
import { useTranslation } from 'next-i18next';
import Router from 'next/router';
import { filter } from 'lodash';
import { useRouter } from 'next/router';
import { useWebshopState } from '@context/webshop';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

function IndexPage() {
  const { t } = useTranslation('webshop');
  const router = useRouter();
  const { id } = router.query;
  const { fetchWebshop, fetchUserCart } = useWebshopState();

  const goToHome = () => {
    Router.push({
      pathname: `/${id}`,
    });
  };

  React.useEffect(() => {
    if (id) {
      fetchWebshop(id);
      if (filter(JSON.parse(localStorage.getItem('userData')), { webShopToken: id }).length > 0) {
        const userData = filter(JSON.parse(localStorage.getItem('userData')), { webShopToken: id })[0];
        fetchUserCart({
          webShopToken: id,
          userId: userData.userId,
        });
      }
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className="container my-24 px-6 mx-auto">
      <section className="mb-32 text-gray-800 text-center">
        <div className="px-6 py-12 md:px-12">
          <h2 className="text-5xl my-12 font-bold tracking-tight">Vourity personuppgiftspolicy</h2>
        </div>
        <div className="flex justify-center">
          <div className="block p-6 rounded-lg shadow-lg bg-white text-left grid justify-items-stretch">
            <p>Uppdaterade: 2019-01-28</p>
            <p>&nbsp;</p>
            <p>
              <strong>Allm&auml;nt</strong>
            </p>
            <p>
              Vourity v&auml;rnar om din personliga integritet och arbetar f&ouml;r att s&auml;kerst&auml;lla att dina personuppgifter skyddas vid anv&auml;ndning av v&aring;ra tj&auml;nster. Nedan f&ouml;ljer v&aring;r policy avseende integritet (&ldquo;
              <strong>
                Personuppgift
                <span style={{ fontWeight: 'normal !msorm' }}>spolicy</span>
              </strong>
              &rdquo;) som fastst&auml;ller hur Vourity AB. c/o Quick office 4-040, R&aring;sta strandv&auml;g 13C, 169 79 Solna, Sverige. Org. nr. 559140-9734, privacy@vourity.com (&ldquo;
              <span style={{ fontWeight: 'normal !msorm' }}>
                <strong>Vourity</strong>
              </span>
              &rdquo; &rdquo;
              <strong>
                V<span style={{ fontWeight: 'normal !msorm' }}>i</span>
              </strong>
              &rdquo;) anv&auml;nder, bearbetar och skyddar dina personuppgifter. Personuppgiftspolicyn g&auml;ller n&auml;r Vourity tillhandah&aring;ller tj&auml;nster och produkter i anslutning till k&ouml;p, service&auml;renden och vid &ouml;vrig kontakt med Vourity.
            </p>
            <p>
              <strong>Vem ansvarar f&ouml;r dina personuppgifter?</strong>
            </p>
            <p>Vourity &auml;r personuppgiftsansvarig och avser att behandla personuppgifter p&aring; ett lagligt, &ouml;ppet och r&auml;ttvist s&auml;tt i enlighet med till&auml;mplig dataskyddslagstiftning bl.a. Europaparlamentets och r&aring;dets f&ouml;rordning (EU) 2016/679 (GDPR). V&aring;ra kontaktuppgifter finns tillg&auml;ngliga i slutet av denna Personuppgiftspolicy.</p>
            <p>
              <strong>N&auml;r behandlar vi dina personuppgifter?</strong>
            </p>
            <p>Som kund hos Vourity behandlar Vi personuppgifter om dig n&auml;r du genomf&ouml;r ett k&ouml;p p&aring; Vouritys hemsida, anv&auml;nder dig av Vouritys support, bes&ouml;ker Vouritys hemsida eller p&aring; annat s&auml;tt har kontakt med Vourity. Vi kan inte tillhandah&aring;lla v&aring;ra tj&auml;nster till dig om du inte till&aring;ter att Vi behandlar dina personuppgifter.</p>
            <p>
              <strong>Profilering</strong>
            </p>
            <p>F&ouml;r prenumeranter kan Vourity komma att behandla personuppgifter genom profilering. S&aring;dan profilering sker med st&ouml;d av samtycke fr&aring;n dig. Du kan n&auml;r som helst &aring;terkalla ditt samtycke. Ett &aring;terkallande av samtycke p&aring;verkar inte lagligheten av behandlingen av dina personuppgifter med samtycke innan dess att &aring;terkallandet skett.</p>
            <p>Profilering inneb&auml;r att Vi analyserar information om hur du anv&auml;nder v&aring;r hemsida, vilka varor, tj&auml;nster och erbjudanden du varit intresserad av, uppgifter om dina ink&ouml;p, vilka av v&aring;ra nyhetsbrev du interagerat med, om du eventuellt har anm&auml;lt dig till n&aring;got av v&aring;ra event samt information om ditt kontoinnehav. Detta g&ouml;r Vi f&ouml;r att tillhandah&aring;lla dig erbjudanden som Vi tror passar dig och f&ouml;r att bjuda in dig till event Vi tror att du skulle vilja g&aring; p&aring;.</p>
            <p>Du &auml;ger r&auml;tt att n&auml;rsomhelst inv&auml;nda mot s&aring;dan profilering. Eventuell inv&auml;ndning skickas till privacy@vourity.com. N&auml;r Vourity har mottagit din anm&auml;lan kommer Vi upph&ouml;ra med att behandla dina personuppgifter f&ouml;r detta &auml;ndam&aring;l.</p>
            <p>
              <strong>Tillg&aring;ng till lagrade personuppgifter</strong>
            </p>
            <p>Vourity kan komma att l&auml;mna ut personuppgifter till bolag som ing&aring;r i samma koncern som Vourity samt till externa samarbetspartners f&ouml;r att uppfylla v&aring;ra &aring;taganden och de &auml;ndam&aring;l som n&auml;mnts ovan. V&aring;ra samarbetspartners &auml;r: Microsoft, Atlassian, Stripe, Swish, SEB, Google, Zendesk, Sendgrid, Twilio, Paypal, Loggly och Apple.</p>
            <p>Uppgifter som vidarebefordras till tredje part anv&auml;nds endast f&ouml;r att tillhandah&aring;lla ovann&auml;mnda tj&auml;nster till dig, t.ex. spedit&ouml;rer i samband med leverans av varor, mediebyr&aring;er f&ouml;r distribution av marknadsf&ouml;ring och kreditupplysnings- eller inkassobyr&aring;er f&ouml;r kreditupplysningskontroller, identitetskontroller och indrivning av fordran.</p>
            <p>Vi &ouml;verf&ouml;r aldrig dina personuppgifter f&ouml;r marknadsf&ouml;rings&auml;ndam&aring;l som tredje part fastst&auml;ller &auml;ndam&aring;l och syfte med.. Vi kommer inte heller s&auml;lja dina personuppgifter till tredje part. Vourity kan komma att l&auml;mna ut dina personuppgifter om det &auml;r n&ouml;dv&auml;ndigt f&ouml;r att f&ouml;lja g&auml;llande lagstiftning eller krav fr&aring;n myndigheter, f&ouml;r att tillvarata Vouritys r&auml;ttsliga intressen eller f&ouml;r att uppt&auml;cka, f&ouml;rebygga eller uppm&auml;rksamma bedr&auml;gerier och andra s&auml;kerhets- eller tekniska problem.</p>
            <p>Vourity str&auml;var alltid efter att enbart lagra personuppgifter inom EU/EES. Dina personuppgifter kan komma att &ouml;verf&ouml;ras och bearbetas i ett land utanf&ouml;r EU/EES (tredje land). De &ouml;verf&ouml;ringar som sker g&ouml;rs till USA, f&ouml;r Google Analytics (analys) och Zendesk (kundtj&auml;nst). Eventuell &ouml;verf&ouml;ring sker i enlighet med g&auml;llande lagstiftning och l&auml;mpliga skydds&aring;tg&auml;rder f&ouml;r s&aring;dan tredjelands&ouml;verf&ouml;ring.</p>
            <p>
              <strong>Hur skyddar vi dina personuppgifter?</strong>
            </p>
            <p>
              Vi har vidtagit tekniska och organisatoriska &aring;tg&auml;rder f&ouml;r att skydda dina uppgifter fr&aring;n f&ouml;rlust, manipulation och obeh&ouml;rig &aring;tkomst. Vi anpassar fortl&ouml;pande v&aring;ra s&auml;kerhets&aring;tg&auml;rder i enlighet med de framsteg och den utveckling som sker p&aring; det tekniska omr&aring;det. F&ouml;r att g&ouml;ra kortk&ouml;p s&aring; s&auml;kra som m&ouml;jligt, skickas all kortinformation i krypterad form. Detta inneb&auml;r att kortinformationen &ouml;verf&ouml;rs via en s&auml;ker anslutning och att dina personuppgifter inte kan l&auml;sas av utomst&aring;ende. F&ouml;r kortk&ouml;p arbetar Vi med ett auktoriserat betalningsombud
              som hj&auml;lper oss att direkt kontrollera med din bank att kortet &auml;r giltigt f&ouml;r k&ouml;p. V&aring;rt betalningsombud bearbetar dina kortuppgifter i enlighet med den internationella s&auml;kerhetsstandarden PCI DSS. Detta inneb&auml;r att s&auml;kerheten &auml;r mycket h&ouml;g vid bearbetningen av dina kortuppgifter. N&auml;r du betalar med kort f&ouml;rbeh&aring;ller Vi oss r&auml;tten att utf&ouml;ra en identitetskontroll.
            </p>
            <p>Vourity kan l&aring;ta tredje part anv&auml;nda dina personuppgifter i marknadsf&ouml;ringssyfte p&aring; best&auml;llning av oss f&ouml;r att marknadsf&ouml;ra v&aring;ra produkter och tj&auml;nster, men Vi kommer aldrig l&aring;ta en tredje part anv&auml;nda dina personuppgifter f&ouml;r att bedriva egen marknadsf&ouml;ring gentemot dig.</p>
            <p>
              <strong>Vilka &auml;r dina r&auml;ttigheter?</strong>
            </p>
            <p>Vourity kommer p&aring; din beg&auml;ran eller p&aring; eget initiativ att r&auml;tta, radera, avidentifiera eller komplettera dina uppgifter om de uppt&auml;cks vara felaktiga, ofullst&auml;ndiga eller missvisande.</p>
            <p>Som registrerad &auml;ger du r&auml;tt att beg&auml;ra:</p>
            <ol>
              <li>Tillg&aring;ng till dina personuppgifter. Du har r&auml;tt att f&aring; ett registerutdrag eller en kopia &ouml;ver vilka personuppgifter Vourity behandlar om dig. Du kan n&auml;rsomhelst utnyttja denna r&auml;tt genom en skriftligt undertecknad ans&ouml;kan.</li>
              <li>R&auml;ttelse av dina personuppgifter. Du har r&auml;tt att beg&auml;ra att Vourity utan on&ouml;digt dr&ouml;jsm&aring;l r&auml;ttar felaktiga eller ofullst&auml;ndiga uppgifter som behandlas om dig.</li>
              <li>Radering av dina personuppgifter. Du har r&auml;tt att beg&auml;ra att dina personuppgifter tas bort om de inte l&auml;ngre &auml;r n&ouml;dv&auml;ndiga f&ouml;r det &auml;ndam&aring;l de samlades in f&ouml;r. Vid ett lagstadgat krav p&aring; lagring av dina personuppgifter eller n&auml;r det finns andra legitima sk&auml;l till varf&ouml;r Vourity m&aring;ste spara dina uppgifter, till exempel obetalda skulder, kan dina personuppgifter inte raderas. Vi kommer d&aring; att avsluta den behandling som g&ouml;rs f&ouml;r andra &auml;ndam&aring;l &auml;n att f&ouml;lja lagstiftningen.</li>
              <li>Begr&auml;nsning av behandling. Du har r&auml;tt att beg&auml;ra att dina personuppgifter endast f&aring;r behandlas f&ouml;r vissa avgr&auml;nsade &auml;ndam&aring;l. Du kan bland annat beg&auml;ra begr&auml;nsning n&auml;r du anser att dina uppgifter &auml;r felaktiga och du har beg&auml;rt r&auml;ttelse enligt ovan. Under tiden uppgifternas korrekthet utreds kommer dess behandling vara begr&auml;nsad.</li>
            </ol>
            <p>Om dina personuppgifter finns lagrade hos Vourity har du r&auml;tt till dataportabilitet. Det inneb&auml;r en r&auml;tt att under vissa f&ouml;ruts&auml;ttningar f&aring; ut och &ouml;verf&ouml;ra vissa av dina personuppgifter i ett strukturerat, allm&auml;nt anv&auml;nt och maskinl&auml;sbart format till en annan personuppgiftsansvarig.</p>
            <p>N&auml;r Vouritys personuppgiftsbehandling utf&ouml;rs med st&ouml;d av en intresseavv&auml;gning har du r&auml;tt att inv&auml;nda mot denna. Vid en inv&auml;ndning forts&auml;tter Vourity endast behandlingen om det finns ber&auml;ttigade sk&auml;l till behandlingen som v&auml;ger tyngre &auml;n dina intressen.</p>
            <p>
              Du kan n&auml;r som helst inv&auml;nda mot att dina personuppgifter behandlas f&ouml;r direkt marknadsf&ouml;ring. Vourity behandlar inte dina personuppgifter f&ouml;r &auml;ndam&aring;l som r&ouml;r direkt marknadsf&ouml;ring om du mots&auml;tter dig s&aring;dan behandling. N&auml;r Vi har mottagit din inv&auml;ndning kommer Vi att upph&ouml;ra med att behandla personuppgifterna f&ouml;r s&aring;dant marknadsf&ouml;rings&auml;ndam&aring;l. Eventuell inv&auml;ndning skickas till privacy@vourity.com. Om du har l&auml;mnat samtycke till Vourity att lagra och anv&auml;nda dina personuppgifter f&ouml;r marknadsf&ouml;rings&auml;ndam&aring;l kan du n&auml;r som helst &aring;terkalla
              n&auml;mnda samtycke. S&aring;dan &aring;terkallelse kan begr&auml;nsas till att endast avse del av behandlingen, exempelvis den som r&ouml;r direkt marknadsf&ouml;ring. Ett eventuellt &aring;terkallande av samtycke skickas till privacy@vourity.com.
            </p>
            <p>
              Som registrerad &auml;ger du r&auml;tt att inge eventuella klagom&aring;l ang&aring;ende behandlingen av dina personuppgifter till beh&ouml;rig myndighet f&ouml;r dataskydd. Du kan hitta mer information om lokala dataskyddsmyndigheter genom att klicka p&aring; f&ouml;ljande l&auml;nk: <a href="http://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm">http://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm</a>.
            </p>
            <p>&nbsp;</p>
            <p>
              <strong>Anv&auml;ndning av cookies och andra sp&aring;rningstekniker</strong>
            </p>
            <p>
              V&aring;r hemsida anv&auml;nder sig av cookies och andra sp&aring;rningstekniker f&ouml;r att f&ouml;rb&auml;ttra din onlineupplevelse. Du hittar mer information om detta i v&aring;r cookiepolicy. Vourity anv&auml;nder bland annat Googles annonstj&auml;nster. Du kan l&auml;sa mer om Googles insamling, delning och anv&auml;ndning av data <a href="https://policies.google.com/privacy/partners">h&auml;r</a>.
            </p>
            <p>
              <strong>Eventuella &auml;ndringar av Vouritys Personuppgiftspolicy</strong>
            </p>
            <p>Vourity f&ouml;rbeh&aring;ller sig r&auml;tten att n&auml;r som helst g&ouml;ra &auml;ndringar i denna Personuppgiftspolicy. Om Personuppgiftspolicyn v&auml;sentligen &auml;ndras kommer Vourity att med rimlig varsel kommunicera detta p&aring; sin hemsida och/eller genom mailutskick till dig.</p>
            <p>
              <strong>Kontaktinformation till personuppgiftsansvarig</strong>
            </p>
            <p>Vi v&auml;rnar om v&aring;ra kunders personuppgifter! Tveka inte att kontakta oss om du har n&aring;gra fr&aring;gor om hur Vi behandlar dina personuppgifter, denna Personuppgiftspolicy eller om du vill beg&auml;ra ett registerutdrag.</p>
            <p>V&aring;r kontaktinformation &auml;r:</p>
            <p>
              Vourity AB
              <br /> c/o Quick office 4-040
              <br /> R&aring;sta strandv&auml;g 13C
              <br /> 169 79 Solna
              <br /> Sverige
            </p>
            <p>Telefon: +46 8 1284 7000</p>
            <p>E-post: privacy@vourity.com</p>
            <p>F&ouml;retagsregister: Bolagsverket</p>
            <p>Organisationsnummer: 559140-9734</p>
            <p>&nbsp;</p>
            <p>
              <strong>Sammanst&auml;llning av personuppgiftshantering</strong>
            </p>
            <table border="1" width="100%">
              <thead>
                <tr>
                  <td width="15%">
                    <p>
                      <strong>&Auml;ndam&aring;l</strong>
                    </p>
                  </td>
                  <td width="25%">
                    <p>
                      <strong>R&auml;ttslig grund</strong>
                    </p>
                  </td>
                  <td width="18%">
                    <p>
                      <strong>Personuppgifter</strong>
                    </p>
                  </td>
                  <td width="20%">
                    <p>
                      <strong>Typ av behandling</strong>
                    </p>
                  </td>
                  <td width="19%">
                    <p>
                      <strong>Lagringstid</strong>
                    </p>
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td width="15%">
                    <p>Vid best&auml;llning/k&ouml;p</p>
                  </td>
                  <td width="25%">
                    <p>Fullg&ouml;rande av avtal</p>
                    <p>Behandling av personuppgifter kr&auml;vs f&ouml;r Vouritys fullg&ouml;rande av &aring;taganden i samband med best&auml;llning/k&ouml;p. Avsaknad av personuppgifter inneb&auml;r att Vourity inte kan fullg&ouml;ra sina &aring;taganden och kan tvingas neka k&ouml;pet.</p>
                  </td>
                  <td width="18%">
                    <p>Namn</p>
                    <p>Adress</p>
                    <p>E-mail</p>
                    <p>Telefon</p>
                    <p>Betalningshistorik</p>
                    <p>Betalningsuppgifter</p>
                    <p>Kreditupplysning</p>
                    <p>Information om k&ouml;p</p>
                  </td>
                  <td width="20%">
                    <p>Leverans</p>
                    <p>Identifikation</p>
                    <p>Betalningshantering</p>
                    <p>Hantering av reklamations&auml;renden</p>
                  </td>
                  <td width="19%">
                    <p>Fullg&ouml;relse av k&ouml;peavtal inklusive leverans och betalning och 15 m&aring;nader d&auml;refter i syfte att hantera reklamations&auml;renden</p>
                  </td>
                </tr>
                <tr>
                  <td width="15%">
                    <p>Fullg&ouml;ra Vouritys r&auml;ttsliga f&ouml;rpliktelser</p>
                  </td>
                  <td width="25%">
                    <p>Lagstadgat krav</p>
                    <p>Behandling av personuppgifter kr&auml;vs enligt lag. Avsaknad av personuppgifter inneb&auml;r att Vourity inte kan efterleva r&auml;ttsliga skyldigheter och kan tvingas neka k&ouml;pet.</p>
                  </td>
                  <td width="18%">
                    <p>Namn</p>
                    <p>Adress</p>
                    <p>E-mail</p>
                    <p>Telefonnummer</p>
                    <p>Betalningshistorik</p>
                    <p>Betalningsuppgifter</p>
                    <p>Kreditupplysningar</p>
                    <p>Information om k&ouml;p</p>
                    <p>Information om eventuella fel/klagom&aring;l</p>
                  </td>
                  <td width="20%">
                    <p>Hantering n&ouml;dv&auml;ndig f&ouml;r att uppfylla Vouritys r&auml;ttsliga f&ouml;rpliktelser enligt lag, domslut eller myndighetsbeslut (t.ex. bokf&ouml;ringslagen, produktansvar mm)</p>
                  </td>
                  <td width="19%">
                    <p>I enlighet med lagstadgade krav</p>
                  </td>
                </tr>
                <tr>
                  <td width="15%">
                    <p>&Auml;renden till kundservice</p>
                  </td>
                  <td width="25%">
                    <p>Ber&auml;ttigat intresse</p>
                    <p>Behandlingen &auml;r n&ouml;dv&auml;ndig f&ouml;r att tillgodose kundens och Vouritys ber&auml;ttigade intresse av kundservice</p>
                  </td>
                  <td width="18%">
                    <p>Namn</p>
                    <p>Adress</p>
                    <p>E-mail</p>
                    <p>Telefonnummer</p>
                    <p>Betalningshistorik</p>
                    <p>Betalningsuppgifter</p>
                    <p>Kreditupplysningar</p>
                    <p>Information om k&ouml;p</p>
                    <p>Information om eventuella fel/klagom&aring;l</p>
                  </td>
                  <td width="20%">
                    <p>Kommunikation och besvarande av fr&aring;gor till v&aring;r kundtj&auml;nst</p>
                    <p>Identifiering och utredning av klagom&aring;l och support&auml;renden</p>
                  </td>
                  <td width="19%">
                    <p>Tills &auml;rendet &auml;r avslutat och ytterligare 3 m&aring;nader f&ouml;r m&ouml;jlighet till uppf&ouml;ljning</p>
                  </td>
                </tr>
                <tr>
                  <td width="15%">
                    <p>Utv&auml;rdering, utveckling och f&ouml;rb&auml;ttring av Vouritys system och tj&auml;nster</p>
                  </td>
                  <td width="25%">
                    <p>Ber&auml;ttigat intresse</p>
                    <p>Behandlingen &auml;r n&ouml;dv&auml;ndig f&ouml;r att tillgodose kundens intresse av utv&auml;rdering, utveckling och f&ouml;rb&auml;ttring av Vouritys tj&auml;nster och system</p>
                  </td>
                  <td width="18%">
                    <p>Korrespondans och feedback om Vouritys tj&auml;nster</p>
                    <p>K&ouml;p- och anv&auml;ndargenererad data</p>
                    <p>Teknisk data s&aring;som exempelvis spr&aring;k, IP-adress, webbl&auml;sare, operativsystem, sk&auml;rmuppl&ouml;sning och plattform.</p>
                  </td>
                  <td width="20%">
                    <p>Anpassning av tj&auml;nster</p>
                    <p>Framtagande av underlag f&ouml;r utveckling och f&ouml;rb&auml;ttring av produktsortiment</p>
                    <p>F&ouml;rb&auml;ttring av IT-system</p>
                    <p>Analyser av personuppgifter g&ouml;rs p&aring; en aggregerad niv&aring; med hj&auml;lp av avidentifierad eller pseudonymiserad data</p>
                  </td>
                  <td width="19%">
                    <p>15 m&aring;nader fr&aring;n insamlandet</p>
                  </td>
                </tr>
                <tr>
                  <td width="15%">
                    <p>F&ouml;rhindra, f&ouml;rebygga och utreda brott mot Vourity och penningtv&auml;tt samt f&ouml;rhindra missbruk av Vouritys tj&auml;nster</p>
                  </td>
                  <td width="25%">
                    <p>Lagstadgat krav och ber&auml;ttigat intresse</p>
                    <p>1.&nbsp;&nbsp;&nbsp;&nbsp; Behandling av personuppgifter vid lagstadgat krav</p>
                    <p>2.&nbsp;&nbsp;&nbsp;&nbsp; Behandlingen &auml;r n&ouml;dv&auml;ndig f&ouml;r att tillgodose kundens och Vouritys ber&auml;ttigade intresse av att f&ouml;rhindra, f&ouml;rebygga och utreda brott samt f&ouml;rhindra missbruk av Vouritys tj&auml;nster</p>
                  </td>
                  <td width="18%">
                    <p>Videoinspelning fr&aring;n kamerabevakning</p>
                    <p>Namn</p>
                    <p>Adress</p>
                    <p>E-mail</p>
                    <p>Telefonnummer</p>
                    <p>Betalningshistorik</p>
                    <p>Betalningsuppgifter</p>
                    <p>Kreditupplysningar</p>
                    <p>Information om k&ouml;p</p>
                    <p>Teknisk data s&aring;som exempelvis spr&aring;k, IP-adress, webbl&auml;sare, operativsystem, sk&auml;rmuppl&ouml;sning och plattform.</p>
                  </td>
                  <td width="20%">
                    <p>F&ouml;rhindra och utreda eventuella bedr&auml;gerier och lag&ouml;vertr&auml;delser</p>
                    <p>F&ouml;rhindra trakasserier, f&ouml;rhindra skr&auml;ppostutskick, penningtv&auml;tt, phising, eller andra &aring;tg&auml;rder som &auml;r f&ouml;rbjudna enligt lag eller Vouritys villkor</p>
                    <p>Skydd och f&ouml;rb&auml;ttring av IT-system</p>
                  </td>
                  <td width="19%">
                    <p>15 m&aring;nader fr&aring;n insamlandet</p>
                  </td>
                </tr>
                <tr>
                  <td width="15%">
                    <p>Administration av kundprofil</p>
                  </td>
                  <td width="25%">
                    <p>Ber&auml;ttigat intresse</p>
                    <p>Behandlingen &auml;r n&ouml;dv&auml;ndig f&ouml;r att tillgodose kundens och Vouritys ber&auml;ttigade intresse av att administrera kundens kundprofil och underl&auml;tta f&ouml;r kunden att nyttja sina r&auml;ttigheter till &auml;ndring, radering, begr&auml;nsning av lagrade personuppgifter samt dataportabilitet</p>
                  </td>
                  <td width="18%">
                    <p>Namn</p>
                    <p>Adress</p>
                    <p>E-mail</p>
                    <p>Telefonnummer</p>
                    <p>Betalningshistorik</p>
                    <p>Betalningsuppgifter</p>
                    <p>Kreditupplysningar</p>
                    <p>Information om k&ouml;p</p>
                    <p>Anv&auml;ndarnamn och l&ouml;senord</p>
                    <p>Inst&auml;llning avseende kundens profil och personliga val</p>
                  </td>
                  <td width="20%">
                    <p>M&ouml;jligg&ouml;ra inloggning</p>
                    <p>S&auml;kerst&auml;lla identitet</p>
                    <p>Ge kunden m&ouml;jlighet att &auml;ndra, rader och begr&auml;nsa lagrade personuppgifter</p>
                    <p>S&auml;kerst&auml;lla korrekta och uppdaterade personuppgifter</p>
                    <p>Erbjuda tillg&aring;ng till k&ouml;p- och betalningshistorik</p>
                    <p>Hantering av kundens val och inst&auml;llningar</p>
                  </td>
                  <td width="19%">
                    <p>15 m&aring;nader fr&aring;n insamlandet</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <button type="button" onClick={() => goToHome()} className="mt-[20px] flex w-[180px] my-0 mx-auto px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out">
              {t('webshop.BACK_TO_START_PAGE')}
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}

export const getStaticPaths = async () => {
  return {
    paths: ['/id/privacy'],
    fallback: true,
  };
};

export const getStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['webshop'])),
    },
  };
};

export default IndexPage;
